export const WIZARD_STEPS = [
  {
    number: 1,
    key: 'personal',
    label: 'Personal Info',
    hint: 'Name, DOB, address',
    path: '/apply/personal'
  },
  {
    number: 2,
    key: 'kyc',
    label: 'Identity & KYC',
    hint: 'Aadhaar, PAN, employment',
    path: '/apply/kyc'
  },
  {
    number: 3,
    key: 'loan',
    label: 'Loan Details',
    hint: 'Amount, tenure, purpose',
    path: '/apply/loan'
  },
  {
    number: 4,
    key: 'documents',
    label: 'Documents',
    hint: 'Salary, bank, ITR',
    path: '/apply/documents'
  },
  {
    number: 5,
    key: 'review',
    label: 'Review & Submit',
    hint: 'Confirm and send',
    path: '/apply/review'
  },
  {
    number: 6,
    key: 'status',
    label: 'Application Status',
    hint: 'Track progress',
    path: '/apply/status'
  }
];

export const MANDATORY_DOCUMENTS = ['AADHAAR_CARD', 'PAN_CARD', 'SALARY_SLIP', 'BANK_STATEMENT'];

/**
 * A step counts as complete when its required data is on the server.
 * Derived from the application object — never tracked separately,
 * so a page refresh can't desynchronise it.
 */
export const isStepComplete = (stepKey, application) => {
  if (!application) return false;

  switch (stepKey) {
    case 'personal':
      return Boolean(
        application.firstName &&
        application.lastName &&
        application.dateOfBirth &&
        application.gender &&
        application.mobileNumber &&
        application.currentAddress &&
        application.city &&
        application.state &&
        application.pinCode &&
        application.residenceType
      );

    case 'kyc':
      return Boolean(
        application.aadhaarLast4 &&
        application.panNumber &&
        application.employmentType &&
        application.employerName &&
        application.monthlyIncome
      );

    case 'loan':
      return Boolean(application.loanAmount && application.tenureMonths && application.loanPurpose);

    case 'documents': {
      const uploaded = new Set((application.documents ?? []).map((d) => d.docType));
      return MANDATORY_DOCUMENTS.every((type) => uploaded.has(type));
    }

    case 'review':
      return application.status !== 'DRAFT';

    case 'status':
      return application.status !== 'DRAFT';

    default:
      return false;
  }
};

export const countCompletedSteps = (application) =>
  WIZARD_STEPS.filter((step) => isStepComplete(step.key, application)).length;

export const STATUS_META = {
  DRAFT: { label: 'Draft', tone: 'neutral' },
  SUBMITTED: { label: 'Submitted', tone: 'review' },
  UNDER_REVIEW: { label: 'Under review', tone: 'review' },
  MORE_INFO_REQUIRED: { label: 'More info needed', tone: 'pending' },
  APPROVED: { label: 'Approved', tone: 'approved' },
  APPROVED_WITH_CONDITIONS: { label: 'Approved with conditions', tone: 'approved' },
  REJECTED: { label: 'Declined', tone: 'declined' },
  WITHDRAWN: { label: 'Withdrawn', tone: 'neutral' }
};
